import {
  REMOVE_MERGED_SERVICES_FOR_SERVICING,
  SERVICINGS_REQUEST,
  SERVICINGS_SUCCESS,
  SERVICINGS_FAILURE,
} from '../actions/servicings'

export default function (state = {}, action) {
  switch(action.type) {
    case REMOVE_MERGED_SERVICES_FOR_SERVICING:
      return {
        ...state,
        [action.servicingId]: {
          ...state[action.servicingId],
          mergedServices: null
        }
      }

    case SERVICINGS_REQUEST: {
      return {
        loading: true,
        ...state,
      }
    }

    case SERVICINGS_SUCCESS: {
      const {
        loading,
        ...newState
      } = state
      return newState
    }

    case SERVICINGS_FAILURE: {
      const {
        loading,
        ...newState
      } = state
      return newState
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/servicings.js